import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { AuctionDetailNavigator } from '@eastcoal/shared/components/AuctionDetailNavigator'
import { BizType } from '@eastcoal/shared/enums/BizType'
import { EntranceType } from '@eastcoal/shared/enums/EntranceType'

import { AUCTION_DETAIL_PAGE_PATH } from '../../../../../../pages/TradeSession/Detail/Auction/Biz/constants/path'

import { HomeAuctionDetailButtonProps } from './interface'

export const HomeAuctionDetailButton = ({
  record: {
    bizId,
    bizType,
    title,
    entranceTicketId,
    entranceType = EntranceType.WATCH
  }
}: HomeAuctionDetailButtonProps) => {
  if (!entranceTicketId || bizType === BizType.PRICE_COMPARE) {
    return null
  }

  return (
    <AuctionDetailNavigator
      auctionTitle={title}
      bizId={bizId}
      bizType={bizType}
      entranceType={entranceType}
      type='primary'
      to={stringifyUrl({
        url: AUCTION_DETAIL_PAGE_PATH,
        query: { id: bizId, entranceType }
      })}
    />
  )
}
